import LUser from './src/main'

LUser.install = function(Vue) {
  Vue.component(LUser.name, LUser)
}

export default LUser
